import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const LOGOMARK = 'https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png'

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F7EF] px-4 py-8">
      <div className="w-full max-w-md rounded-[28px] bg-[#FFFFFF] px-6 py-10 text-center shadow-[0_20px_60px_rgba(16,24,40,0.08)]">
        <img src={LOGOMARK} alt="" className="mx-auto h-10 w-10" />
        <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-[#4B5563]">404</p>
        <h1 className="text-3xl font-bold mt-2 tracking-tight text-[#0F172A]">Page not found</h1>
        <p className="mt-2 text-[#4B5563]">That link doesn't go anywhere in Athios.</p>
        <Link
          to="/"
          className="mt-6 inline-flex h-12 items-center justify-center rounded-xl bg-[#C0FD72] px-6 font-semibold text-[#0F172A] hover:bg-[#B4F25F]"
        >
          Go to your dashboard
        </Link>
      </div>
    </div>
  )
}

export default NotFound
